import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { TMeetingRoom } from "apis/meetings/meeting-room";
import { useRef, useState } from "react";
import * as NonModal from "uis/non-modal";

const MeetingRoomCard = ({
  meetingRoom,
  isOnlyDetail = false,
}: {
  meetingRoom: TMeetingRoom;
  isOnlyDetail?: boolean;
}) => {
  const [openInfo, setOpenInfo] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);

  //* INFO: 상세 정보 모달의 위치를 계산하는 함수
  const getMeetingRoomInfoModalPositionLeft = (widgetLeft: number, widgetRight: number) => {
    if (widgetLeft + 320 > window.innerWidth) {
      return widgetRight - 320;
    } else {
      return widgetLeft;
    }
  };

  return (
    <Container className="meeting-room-card">
      {isOnlyDetail ? (
        <></>
      ) : (
        <OverViewContainer>
          <TitleContainer>
            <UI.Icon name="door" size={24} color="var(--alias-color-label-neutral)" />
            <UI.Typography type="body02 normal" fontStyle="bold" color="var(--alias-color-label-normal)">
              {meetingRoom.name}
            </UI.Typography>
          </TitleContainer>
          <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
            {meetingRoom.building?.name ?? "건물 미설정"} - {meetingRoom.floor?.name ?? "층 미설정"}
          </UI.Typography>
        </OverViewContainer>
      )}
      <div
        style={{
          position: "relative",
          cursor: "pointer",
        }}
        onMouseEnter={() => setOpenInfo(true)}
        onMouseLeave={() => setOpenInfo(false)}
        tabIndex={0}
        ref={ref}
      >
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-alternative)"
          style={{
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          상세 정보
        </UI.Typography>
      </div>
      <NonModal.MeetingRoomHorizontalNonModal
        meetingRoom={meetingRoom}
        open={openInfo}
        position={{
          top: 222 + 74,
          left: getMeetingRoomInfoModalPositionLeft(
            ref.current?.getBoundingClientRect().left ?? 0,
            ref.current?.getBoundingClientRect().right ?? 0
          ),
        }}
      />
    </Container>
  );
};

export default MeetingRoomCard;

const OverViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Container = styled.div`
  display: flex;
  min-width: 100px;
  max-width: 280px;
  box-sizing: border-box;
  width: 100%;
  padding: 0px 4px;
  flex-direction: column;
  gap: 4px;

  p {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  align-self: stretch;
  margin-bottom: 2px;
`;
